import { persist } from "zustand/middleware";
import { shallow } from "zustand/shallow";
import { createWithEqualityFn as create } from "zustand/traditional";

import { CountryCode } from "@krea/shared/types/common";

type ILoginMethod = "bankid" | "password";

interface ILoginState {
  loginMethod: ILoginMethod;
  setLoginMethod: (loginMethod: ILoginMethod) => void;
  countryCode: CountryCode;
  setCountryCode: (countryCode: CountryCode) => void;
}

export const useLoginStore = create<ILoginState>()(
  persist<ILoginState>(
    (set) => ({
      loginMethod: "bankid",
      setLoginMethod: (loginMethod) => set({ loginMethod }),
      countryCode: CountryCode.SE,
      setCountryCode: (countryCode) => set({ countryCode }),
    }),
    {
      name: "login",
    },
  ),
  shallow,
);
